var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMailService = function SvgMailService(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.041 146H12L35.0612 26H152L129.041 146Z",
    fill: "#E6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 129.5H15L14 135.5H131L132 129.5Z",
    fill: "#9FA4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 128.5C8 127.672 8.67157 127 9.5 127H136.5C137.328 127 138 127.672 138 128.5C138 129.328 137.328 130 136.5 130H9.5C8.67157 130 8 129.328 8 128.5Z",
    fill: "#313E48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6004 106.39L89.2004 89.8898C89.6004 89.6898 89.6004 89.1898 89.2004 88.9898L52.9004 75.1898L14.6004 88.9898C14.5004 88.9898 14.5004 89.1898 14.6004 89.1898L55.6004 106.39Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 106.39L14 89.0898V128.09L53.8 145.79C54 145.89 54.2 145.69 54.2 145.49V106.39Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2 145.99L90.2 125.49V89.3898L45.5 102.09L54.2 145.99Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6994 131.29L17.3994 126.79V93.7898L29.6994 98.2898V131.29Z",
    fill: "#FEEAE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6146 73.5906L90.5912 87.6479L90.732 87.7417C92.0206 88.6007 91.8683 90.5327 90.4708 91.2315L90.4612 91.2362L56.2488 108.037L14.7234 90.6165C14.3532 90.4983 14.07 90.2521 13.8957 89.9906C13.6823 89.6706 13.625 89.3373 13.625 89.0898C13.625 88.8423 13.6823 88.509 13.8957 88.189C14.0798 87.9128 14.3856 87.6536 14.787 87.5443L53.6146 73.5906ZM19.0781 89.1901L56.1512 104.743L87.1167 89.5364L53.5854 76.789L19.0781 89.1901Z",
    fill: "#313E48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5996 87.5898C15.428 87.5898 16.0996 88.2614 16.0996 89.0898V127.115L53.2996 143.659V106.39C53.2996 105.561 53.9712 104.89 54.7996 104.89C55.628 104.89 56.2996 105.561 56.2996 106.39V145.49C56.2996 146.061 56.0317 146.574 55.6349 146.905C55.2049 147.263 54.4915 147.49 53.7707 147.152L13.0996 129.064V89.0898C13.0996 88.2614 13.7712 87.5898 14.5996 87.5898Z",
    fill: "#313E48"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8001 87.8898C91.6285 87.8898 92.3001 88.5614 92.3001 89.3898V126.362L55.5423 147.293C54.8224 147.703 53.9065 147.452 53.4966 146.732C53.0866 146.012 53.3379 145.096 54.0578 144.686L89.3001 124.618V89.3898C89.3001 88.5614 89.9716 87.8898 90.8001 87.8898Z",
    fill: "#313E48"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0005 103.25C22.2989 102.477 23.1673 102.092 23.9401 102.391L34.0401 106.291C34.813 106.589 35.1975 107.457 34.8991 108.23C34.6007 109.003 33.7323 109.388 32.9595 109.089L22.8595 105.189C22.0867 104.891 21.7021 104.022 22.0005 103.25Z",
    fill: "#313E48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0094 112.727C22.3202 111.959 23.1947 111.589 23.9626 111.899L36.5626 116.999C37.3305 117.31 37.701 118.185 37.3902 118.953C37.0794 119.721 36.2049 120.091 35.437 119.78L22.837 114.68C22.0691 114.369 21.6986 113.495 22.0094 112.727Z",
    fill: "#313E48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0996 92.9898L23.5996 89.0898L52.5996 77.7898L63.3996 82.4898L34.0996 92.9898Z",
    fill: "#FEEAE1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9147 81.9126C36.2335 81.148 37.1118 80.7866 37.8764 81.1053L73.3764 95.9053C74.1411 96.2241 74.5025 97.1024 74.1837 97.867C73.8649 98.6317 72.9867 98.9931 72.222 98.6743L36.722 83.8743C35.9574 83.5556 35.5959 82.6773 35.9147 81.9126Z",
    fill: "#313E48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2998 59.4898C50.1282 59.4898 50.7998 60.1614 50.7998 60.9898V66.9898C50.7998 67.8182 50.1282 68.4898 49.2998 68.4898C48.4714 68.4898 47.7998 67.8182 47.7998 66.9898V60.9898C47.7998 60.1614 48.4714 59.4898 49.2998 59.4898Z",
    fill: "#313E48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5 63.8898C44.5 63.0614 45.1716 62.3898 46 62.3898H52.6C53.4284 62.3898 54.1 63.0614 54.1 63.8898C54.1 64.7183 53.4284 65.3898 52.6 65.3898H46C45.1716 65.3898 44.5 64.7183 44.5 63.8898Z",
    fill: "#313E48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4004 43.7898C62.2288 43.7898 62.9004 44.4614 62.9004 45.2898V51.2898C62.9004 52.1182 62.2288 52.7898 61.4004 52.7898C60.572 52.7898 59.9004 52.1182 59.9004 51.2898V45.2898C59.9004 44.4614 60.572 43.7898 61.4004 43.7898Z",
    fill: "#313E48"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5 48.1898C56.5 47.3614 57.1716 46.6898 58 46.6898H64.6C65.4284 46.6898 66.1 47.3614 66.1 48.1898C66.1 49.0182 65.4284 49.6898 64.6 49.6898H58C57.1716 49.6898 56.5 49.0182 56.5 48.1898Z",
    fill: "#313E48"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2998 111.59L85.2998 99.8898V120.79L62.7998 132.99L62.2998 111.59Z",
    fill: "#F9AF8D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8 97.4438V121.683L61.3577 135.478L60.7783 110.681L86.8 97.4438ZM63.8216 112.499L64.2422 130.501L83.8 119.897V102.336L63.8216 112.499Z",
    fill: "#313E48"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2998 114.39L71.3998 112.39C73.1998 111.19 74.6998 111.09 74.7998 113.69C74.8998 115.29 74.2998 116.69 73.3998 117.89L75.4998 120.99L73.2998 122.39L71.4998 119.49L70.3998 120.19L70.4998 124.19L68.5998 125.49L68.2998 114.39ZM71.3998 117.49C72.3998 116.79 72.8998 115.89 72.8998 114.79C72.8998 113.69 72.2998 113.69 71.2998 114.39L70.2998 114.99L70.3998 118.09L71.3998 117.49Z",
    fill: "#313E48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 115.19L75.5 112.39L77.6 111.09L78.2 112.09C78.4 112.49 78.6 112.79 78.8 113.19H78.9C79 112.59 79.2 111.99 79.3 111.49L79.7 109.89L81.7 108.59L80 114.09L82.2 116.89L80.1 118.19L79.4 117.19C79.2 116.89 79 116.49 78.7 116.09H78.6C78.5 116.69 78.3 117.29 78.2 117.89L77.7 119.59L75.7 120.89L77.5 115.19Z",
    fill: "#313E48"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2451 49.4905V27.5247H130.216C139.458 27.5247 146.9 34.9666 146.9 44.2091V71.8165C146.9 74.8173 144.5 77.2179 141.499 77.2179H90.2451",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7451 26.0247H130.216C140.287 26.0247 148.4 34.1382 148.4 44.2091V71.8165C148.4 75.6457 145.328 78.7179 141.499 78.7179H90.2451C89.4167 78.7179 88.7451 78.0464 88.7451 77.2179C88.7451 76.3895 89.4167 75.7179 90.2451 75.7179H141.499C143.671 75.7179 145.4 73.9889 145.4 71.8165V44.2091C145.4 35.7951 138.63 29.0247 130.216 29.0247H91.7451V49.4905C91.7451 50.319 91.0735 50.9905 90.2451 50.9905C89.4167 50.9905 88.7451 50.319 88.7451 49.4905V26.0247Z",
    fill: "#313E48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.69 77.0979H76.9213C74.1606 77.0979 72 74.9373 72 72.1766V46.1296C72 35.6869 80.4022 27.2846 90.845 27.2846C101.288 27.2846 109.69 35.6869 109.69 46.1296V77.0979Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.845 28.7846C81.2307 28.7846 73.5 36.5153 73.5 46.1296V72.1766C73.5 74.1089 74.989 75.5979 76.9213 75.5979H108.19V46.1296C108.19 36.5153 100.459 28.7846 90.845 28.7846ZM109.69 77.0979H111.19V46.1296C111.19 34.8584 102.116 25.7846 90.845 25.7846C79.5738 25.7846 70.5 34.8584 70.5 46.1296V72.1766C70.5 75.7658 73.3321 78.5979 76.9213 78.5979H109.69V77.0979Z",
    fill: "#313E48"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.934 10.6606C122.762 10.6606 123.434 11.3322 123.434 12.1606V52.6114C123.434 53.4398 122.762 54.1114 121.934 54.1114C121.105 54.1114 120.434 53.4398 120.434 52.6114V12.1606C120.434 11.3322 121.105 10.6606 121.934 10.6606Z",
    fill: "#313E48"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.578 10H121.934V20.5628H139.578V10Z",
    fill: "#EADB9E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.434 8.5H141.078V22.0628H120.434V8.5ZM123.434 11.5V19.0628H138.078V11.5H123.434Z",
    fill: "#313E48"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.415 50.5104C124.32 50.5104 123.434 51.3973 123.434 52.4914C123.434 53.5854 124.32 54.4723 125.415 54.4723C126.509 54.4723 127.395 53.5854 127.395 52.4914C127.395 51.3973 126.509 50.5104 125.415 50.5104ZM120.434 52.4914C120.434 49.7405 122.664 47.5104 125.415 47.5104C128.165 47.5104 130.395 49.7405 130.395 52.4914C130.395 55.2423 128.165 57.4723 125.415 57.4723C122.664 57.4723 120.434 55.2423 120.434 52.4914Z",
    fill: "#313E48"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.45 49.6106H83.2832V76.7378H109.45V49.6106Z",
    fill: "#A5CAEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7832 48.1106H110.95V78.2378H81.7832V48.1106ZM84.7832 51.1106V75.2378H107.95V51.1106H84.7832Z",
    fill: "#313E48"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M128.966 77.6531H109.978V128.29H128.966V77.6531Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.478 76.1531H130.466V129.79H108.478V76.1531ZM111.478 79.1531V126.79H127.466V79.1531H111.478Z",
    fill: "#313E48"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9414 26.5715C90.7698 26.5756 91.438 27.2506 91.4338 28.079L91.3284 49.04C91.3242 49.8684 90.6492 50.5366 89.8208 50.5324C88.9924 50.5282 88.3242 49.8533 88.3284 49.0249L88.4339 28.0639C88.438 27.2355 89.113 26.5673 89.9414 26.5715Z",
    fill: "#313E48"
  })));
};
export { SvgMailService as ReactComponent };
export default __webpack_public_path__ + "static/media/mail-service.e478ef7a.svg";